<template>
  <section class="n-section-primary" :style="`background-color: var(--c-${vars.backgroundColor})`">
    <div
      class=":tw-w-full tw-flex tw-w-full tw-flex-col"
      :class="vars.isReversedBool ? 'lg:tw-flex-row-reverse' : 'lg:tw-flex-row'"
      style="border-radius: var(--rounded)"
    >
      <div class="tw-w-full tw-self-center lg:tw-max-w-[515px]">
        <LibraryImage
          :w-ratio="0.78"
          :h-ratio="1"
          :src="vars.photoImage"
          image-class="tw-h-auto tw-w-full"
          style="object-fit: cover; border-radius: var(--rounded)"
        />
      </div>

      <!-- Form alanı -->
      <div class="tw-flex tw-w-full tw-flex-col md:tw-p-10 xl:tw-px-20">
        <h2 v-if="vars.titleText" class="tw-mb-6 tw-mt-6 tw-text-start md:tw-mb-10 lg:tw-mt-0">{{ vars.titleText }}</h2>
        <library-form v-if="form" :form="form" version="v2" :component="component"></library-form>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'GuideSection',

  mixins: [ComponentMixin],

  data() {
    return {
      form: null,
      variants: {
        v1: 'v1',
        v2: 'v2',
      },
    };
  },

  created() {
    this.form = this.parseFormV2(this.vars.guideForm);
  },
});
</script>
